import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
 
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
 
import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext } from "react";
import { stateData } from "@/constants/electionConfig";
// import OldElectionScreen from "@/screens/OldStateElection";
const OldElectionScreen = dynamic(() => import("@/screens/OldStateElection"));

export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  electionCategory = null,
}) {
  const isMobileDevice = useIsMobile();
  const masterConfig = useContext(MasterConfigContext);
  
//   let metaData = {
//     title: `Maharashtra Election 2024: Key Candidates of Maharashtra Assembly Elections 2024, महाराष्ट्र विधान सभा चुनाव के प्रमुख उम्मीदवार - NewsTak`,
//     description: `Get the list of Maharashtra Vidhan Sabha Chunav 2024 Key candidates (महाराष्ट्र विधान सभा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, and महाराष्ट्र विधानसभा चुनाव उम्मीदवार in Hindi at NewsTak.in.
// `,
//     keywords: `Maharashtra Election 2024 Key Candidate, Maharashtra Assembly Election 2024 Key Candidate, Maharashtra vidhan sabha chunav 2024 Candidate,Maharashtra 2024 candidate list, महाराष्ट्र विधान सभा चुनाव 2024 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate, चुनाव समाचार
// `,
//   };
  const state_data = stateData[electionCategory];
  
  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      > 
        <OldElectionScreen
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath="maharashtra-assembly/key-candidates-list-2024"
          electionPath={`${electionCategory}/key-candidates-list`}
          isMobileDevice={isMobileDevice}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          electionPassedCategory={
            state_data?.["key-candidates-list"]?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.["key-candidates-list"]?.state} //"Delhi"
          stateHindi={state_data?.["key-candidates-list"]?.stateNameHi} //"महाराष्ट्र"
          metaData={state_data?.["key-candidates-list"]?.metaData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";
  let url = ctx?.resolvedUrl;
  url = url.split("/key-candidates-list")[0];
  // console.log("url2", url);
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");
 
  if(!stateData[electionCategory]){
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);
 
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
